import { FormEvent } from "react"
import { useForm } from "@inertiajs/react"
import { useIntl } from "react-intl"
import { Button } from "@/components/ui/button"
import { Dialog, DialogContent, DialogFooter, DialogHeader, DialogTitle } from "@/components/ui/dialog"
import { Input } from "@/components/ui/input"
import type { SourceDetail } from "@/types/generations"

export function RenameSourceDialog({
  source,
  open,
  onOpenChange,
}: {
  source: Pick<SourceDetail, "id" | "title">
  open: boolean
  onOpenChange: (open: boolean) => void
}) {
  const intl = useIntl()
  const form = useForm({ title: source.title })

  const submit = (e: FormEvent) => {
    e.preventDefault()
    form.patch(`/sources/${source.id}`, { preserveScroll: true, onSuccess: () => onOpenChange(false) })
  }

  return (
    <Dialog open={open} onOpenChange={onOpenChange}>
      <DialogContent size="sm">
        <form onSubmit={submit}>
          <DialogHeader>
            <DialogTitle>{intl.formatMessage({ id: "sources.rename" })}</DialogTitle>
          </DialogHeader>
          <div className="mt-4 space-y-2">
            <label htmlFor="source-title">{intl.formatMessage({ id: "sources.title_label" })}</label>
            <Input
              id="source-title"
              required
              autoFocus
              maxLength={120}
              aria-invalid={!!form.errors.title}
              value={form.data.title}
              onChange={(e) => form.setData("title", e.target.value)}
            />
            {form.errors.title && <p className="text-xs text-danger-display">{form.errors.title}</p>}
          </div>
          <DialogFooter className="mt-6">
            <Button type="button" variant="secondary" onClick={() => onOpenChange(false)}>
              {intl.formatMessage({ id: "common.cancel" })}
            </Button>
            <Button type="submit" disabled={form.processing}>
              {intl.formatMessage({ id: "common.save" })}
            </Button>
          </DialogFooter>
        </form>
      </DialogContent>
    </Dialog>
  )
}
